import { render, staticRenderFns } from "./UploadVerification.vue?vue&type=template&id=127365c6&"
import script from "./UploadVerification.vue?vue&type=script&lang=js&"
export * from "./UploadVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports